
<!-- Детализация расчета -->

<template>

<elements
	v-if="init_done"
	ref="elements"
	:service="service"
	:attrs="attrs"
	essence_name_genetive_case="детализации"
	essence_name_for_plural_1="детализация"
	essence_name_for_plural_234="детализации"
	essence_name_for_plural_others="детализаций"
	without_add
	without_back_button
	not_able_for_delete
	without_details
	:postfix_for_storage_name="`details_profitable_${group_id}`"
	:additional_query="{ 'obj.group_id' : group_id }"
>

	<template v-slot:title><h4>Детализация</h4></template>

</elements>

</template>

<script>

import api from "../../../../../api"
import elements from "../../../../elements"

export default
{
	props :
	{
		group_id : String,
		cost_evaluation_data : Object,
	},

	components :
	{
		elements,
	},

	data()
	{
		return {

			service : "cadastral_profitable_details",

			attrs : [],
			init_done : false,
    
		}
	},

	beforeMount()
	{
		this.attrs = []

		return api.call(this, "cadastral_profitable_details", "get_structure", {},
			response =>
			{
				for (const [ key, value ] of Object.entries(response.data) )
					if(key.includes("info") || key.includes("name"))
					{
						const type = ( key == "info.A" || key == "info.B" || key == "info.C" || key == "info.D" || key == "obj.name") ? "str" : "number"
						let label = value.replace("Информация / ", "").replace("Объект / ", "")
						let is_cadastral_number

						if(key == "info.C") // Функциональная подгруппа
						{
							if( api.has_oks() )
								this.attrs.push(
									{
										key : key,
										label : label,
										type : type,
										sortable : true,
										visible : false,
										in_query : true,
										reference : { attr_key : "attrs.functional_sub_group" },
									})
						}
						else
						{
							const visible = ( key == "obj.name" || key == "info.E" || key == "info.AZ" || key == "info.BA" ) // КН, Площадь, УПКС, Кадастровая стоимость
							const visible_if_no_visible = ( key == "obj.name" || key == "info.E" || key == "info.AZ" || key == "info.BA" ) // КН, Площадь, УПКС, Кадастровая стоимость
							var my_formatter = null

							if (key == "info.AZ" || key == "info.BA")
								my_formatter = elem => { return { value : api.format_cost(elem.value, "", "") } }
							else if(key == "obj.name")
								is_cadastral_number = true

							if( key == "info.F_all" || key == "info.F_low" || key == "info.F_middle" || key == "info.F_high" )
							{
								try
								{
									const setups = this.cost_evaluation_data.capitalization.net_operating_income.actual_gross_income.potential_gross_income

									if( setups.type == "Данные Пользователя" )
										continue

									const setups_analogues = setups.analogues

									if( setups_analogues.with_season_factors )
									{
										if( key == "info.F_all" )
											continue

										/*
										4208 - #38
										const setups_season = setups_analogues.season_factor

										if( key == "info.F_low" )
										{
											if( ! setups_season.low_season_count.state )
												continue
										}

										if( key == "info.F_middle" )
										{
											if( ! setups_season.middle_season_count.state )
												continue
										}

										if( key == "info.F_high" )
										{
											if( ! setups_season.high_season_count.state )
												continue
										}
										*/
									}
									else
									{
										if( key != "info.F_all" )
											continue
									}
								}
								catch
								{
									continue
								}
							}

							const desc =
								{
									key : key,
									label : label,
									type : type,
									sortable : true,
									visible : visible,
									visible_if_no_visible : visible_if_no_visible,
									is_cadastral_number : is_cadastral_number,
									in_query : true,
									my_formatter : my_formatter,
								}

							this.attrs.push(desc)
						}
					}

				this.init_done = true
			})
	},

	methods :
	{
		refresh()
		{
			this.$refs.elements.refresh()
		},
	}
}

</script>

